<script>
  import { onMount } from 'svelte';
  import { auth } from './lib/stores/auth.svelte.js';
  import { router } from './lib/stores/router.svelte.js';
  import Login from './components/Login.svelte';
  import Shell from './components/Shell.svelte';

  onMount(() => {
    auth.init();
  });

  let upgradeToast = $state(null);

  $effect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const upgrade = params.get('upgrade');
    if (upgrade === 'success') {
      upgradeToast = 'Welcome to Unlimited! Your account is upgraded.';
      setTimeout(() => { upgradeToast = null; }, 6000);
      window.history.replaceState({}, '', window.location.pathname);
    } else if (upgrade === 'cancelled') {
      window.history.replaceState({}, '', window.location.pathname);
    }
  });
</script>

{#if upgradeToast}
  <div class="upgrade-toast">
    <span class="toast-icon">✓</span>
    <span class="toast-text">{upgradeToast}</span>
    <button class="toast-x" on:click={() => upgradeToast = null} aria-label="Dismiss">×</button>
  </div>
{/if}

{#if auth.loading}
  <div class="loading">Loading…</div>
{:else if !auth.isAuthenticated}
  <Login />
{:else if !auth.isAllowed}
  <div class="gate">
    <h1>app-biz-builder</h1>
    <p class="muted">This tool is in private alpha. Open access coming soon.</p>
    <button on:click={() => auth.signOut()}>Sign out</button>
  </div>
{:else}
  <Shell />
{/if}

<style>
  .loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-dim);
    font-size: 13px;
  }
  .gate {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 24px;
    text-align: center;
  }
  .gate h1 { margin: 0; font-size: 22px; font-weight: 500; }
  .gate p { margin: 0; max-width: 320px; }

  .upgrade-toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(122, 184, 122, 0.95);
    color: #000;
    padding: 10px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 500;
    z-index: 1000;
    box-shadow: 0 6px 24px rgba(0,0,0,0.4);
    animation: toast-in 0.25s ease-out;
  }
  @keyframes toast-in {
    from { opacity: 0; transform: translate(-50%, -10px); }
    to { opacity: 1; transform: translate(-50%, 0); }
  }
  .toast-icon { font-size: 16px; }
  .toast-x {
    background: transparent;
    border: none;
    color: #000;
    font-size: 18px;
    line-height: 1;
    padding: 0 4px;
    cursor: pointer;
    margin-left: auto;
  }
</style>
